// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  min-height: 25px;
  min-width: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-button/s1-button.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF","sourcesContent":["button {\n  min-height: 25px;\n  min-width: 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
